import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-wizard-reglage',
  templateUrl: './wizard-reglage.component.html',
  styleUrls: ['../../base/wizard/wizard-hp-base-component.scss', './wizard-reglage.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
 
})
export class WizardReglageComponent extends WizardHpBaseComponent implements OnInit {
  @Input() catalog_selected;
  constructor(chgDetectorRef: ChangeDetectorRef, mainSimulateur: SimulateurComponent, hpService: HpService, router: Router) {
    super(chgDetectorRef, hpService, router);

  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getHpService().emitDataChange();
  }

}
